<template>
  <!-- eslint-disable max-len -->
  <svg display="none">
    <defs>
      <g id="img-pizza-quarters">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          d="M10.4167 19.983C15.4685 19.7759 19.5536 15.8211 19.9658 10.8248H10.4167V19.983ZM20 9.99149C20 4.60822 15.7463 0.218456 10.4167 1.52265e-05V9.99149L20 9.99149ZM9.58333 1.52251e-05C4.25372 0.218456 0 4.60822 0 9.99149L9.58333 9.99149V1.52251e-05ZM0.0342281 10.8248H9.58333V19.983C4.53155 19.7759 0.446412 15.8211 0.0342281 10.8248Z"
          clip-rule="evenodd"
        />
      </g>
      <g id="img-pizza-thirds">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          d="M10.3846 6.5761e-09V9.4475L19.3324 13.5976C19.7636 12.4802 20 11.2659 20 9.99637C20 4.60035 15.7292 0.202179 10.3846 6.5761e-09ZM9.61537 1.41241e-06V9.46345L0.672725 13.611C0.238286 12.4899 0 11.271 0 9.99637C0 4.60036 4.27077 0.2022 9.61537 1.41241e-06ZM0.992286 14.3462C2.60985 17.6921 6.03551 20 10 20C13.9695 20 17.3988 17.6863 19.0138 14.3335L10.0169 10.1606L0.992286 14.3462ZM10.0165 10.1352L10.0178 10.1347L10.017 10.1364L10.0165 10.1352Z"
          clip-rule="evenodd"
        />
      </g>
      <g id="img-pizza-full">
        <ellipse
          xmlns="http://www.w3.org/2000/svg"
          cx="10"
          cy="10"
          rx="10"
          ry="10"
        />
      </g>
      <g id="img-pizza-half">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          d="M9.61537 -2.47232e-09C4.27077 0.202272 0 4.60203 0 10C0 15.398 4.27077 19.7977 9.61537 20V-2.47232e-09ZM10.4487 19.9974C15.7633 19.7625 20 15.3764 20 10C20 4.62361 15.7633 0.237476 10.4487 0.00262776V19.9974Z"
          clip-rule="evenodd"
        />
      </g>
      <g id="img-merge">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M0 3.75C0 3.05977 0.559766 2.5 1.25 2.5H5.64844C6.41016 2.5 7.125 2.84531 7.60156 3.43828L11.8516 8.75H15V6.875C15 6.49609 15.2266 6.15234 15.5781 6.00781C15.9297 5.86328 16.332 5.94531 16.5664 6.21094L19.6914 9.33594C20.0898 9.70312 20.0898 10.2969 19.6914 10.6289L16.5664 13.7539C16.332 14.0547 15.9297 14.1367 15.5781 13.9922C15.2266 13.8477 15 13.5039 15 13.125V11.25H11.8516L7.60156 16.5273C7.12891 17.1562 6.41016 17.5 5.64844 17.5H1.25C0.559766 17.5 0 16.9414 0 16.25C0 15.5586 0.559766 15 1.25 15H5.64844L9.64844 10L5.64844 5H1.25C0.559766 5 0 4.44141 0 3.75Z"
        />
      </g>
    </defs>
  </svg>
</template>



<script>
  /*
    NOTE: To add a new icon:

    1. Make sure the SVG file uses a square ratio (20x20 canvas) and the icon is centered
    2. Upload the SVG file here: https://svgsprite.com/tools/svg-sprite-generator
    3. Then copy/paste the new group(s) in to the SVG source above.
    4. Remove "fill" attributes to inherit fill color from CSS

    (Currently, this process isn't worth the time/effort to fully automate)
  */

  export default {
    name: 'SvgIconLibrary'
  };
</script>
